/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Choice/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaChoice from 'DesignSystem/TysiaChoice/index'
import TysiaChoiceText from 'DesignSystem/TysiaChoice/TysiaChoiceText/index'



/** @type {import('Simple/types.js').View} */
export default function Choice({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/PatientOptions/Existing/Content/AppointmentSelect/Content/Content/AppointmentOptions/Choice"
  
}) {
let optionIdValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'id',
})
let optionItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'option_item',
path: 'isFirst',
})
let optionItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'option_item',
path: 'isLast',
})
let optionIsSelectedValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'isSelected',
})
let optionIsDisabledValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'isDisabled',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let optionTextValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'text',
})
let optionIsSelectedValueData1 = fromData.useDataValue({ viewPath,
context: 'option',
path: 'isSelected',
})
let optionIsDisabledValueData1 = fromData.useDataValue({ viewPath,
context: 'option',
path: 'isDisabled',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaChoice
  viewPath={`${viewPath}/TysiaChoice`}
 marginTop={0}
 width={82}
 height={24}
 borderTopRightRadius={optionItemIsLastValueData ? dtSpaceXxs : "0px"}
 borderBottomRightRadius={optionItemIsLastValueData ? dtSpaceXxs : "0px"}
 borderTopLeftRadius={optionItemIsFirstValueData ? dtSpaceXxs : "0px"}
 borderBottomLeftRadius={optionItemIsFirstValueData ? dtSpaceXxs : "0px"}
 paddingBottom={dtSpaceXxs}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
 paddingTop={dtSpaceXxs}
 backgroundColor={optionIsSelectedValueData ? dtColorsGreen700 : optionIsDisabledValueData ? dtColorsNeutral200 : dtColorsWhite}
 borderColor={optionIsDisabledValueData ? dtColorsNeutral200 : dtColorsNeutral300}
 borderWidth={1}
 alignItems="center"
 justifyContent="center"
 cursor={optionIsDisabledValueData ? "not-allowed" : "pointer"}
 data={optionItemIsFirstValueData ? "option_item.isLast" : optionItemIsLastValueData ? "option.isSelected" : optionIsSelectedValueData ? "option.isDisabled" : "option.id"}
 id={optionIdValueData}
 onClick={onClick}
 data={optionItemIsFirstValueData ? "option_item.isLast" : optionItemIsLastValueData ? "option.isSelected" : optionIsSelectedValueData ? "option.isDisabled" : "option_item.isFirst"}
>
{childProps => (
<TysiaChoiceText
{...childProps}
  viewPath={`${viewPath}/TysiaChoiceText`}
 data={optionIsSelectedValueData1 ? "option.isDisabled" : "option.text"}
 text={optionTextValueData}
 color={optionIsSelectedValueData1 ? dtColorsWhite : optionIsDisabledValueData1 ? dtColorsNeutral400 : dtColorsNeutral900}
 data={optionIsSelectedValueData1 ? "option.isDisabled" : "option.isSelected"}
/>
)}
</TysiaChoice>
{children}
</React.Fragment>)
}